<template>
  <div id="app" class="router-view">
    <keep-alive :include="['QuickLogin','Packages']">
      <router-view  :loginStatus="loginStatus"/>
    </keep-alive>
  </div>
</template>
<script>
    import { isEmptyObject, getUrlParam, getUrlParamNotDecode } from './utils/util'
    import dsBridgeUtil from './utils/dsBridgeUtil'
    import cookie from './utils/cookie'
    import langArray from './data/appLangArray'
    import { setTheme } from '@/utils/theme.js';

  export default {
    data(){
      return {
        loginStatus:"default"
      }
    },
    mounted() {
      let that = this;

      this.checkProjectConfig();
      
      if (this.$APP_CONFIG.env !== 'prod') {
        this.debug(document, () => {
          this.$toast({
            message: "正在进入调试页面",
            onClose: function () {
              that.$router.push({ name: "test" });
            },
          });
        });
      }
      
      // 对于阿拉伯语进行镜像反转
      let langType = cookie.getCookie('langType')
      if(langType === 'ar-AE') {
          const htmlNode = document.documentElement;  
          htmlNode.setAttribute('dir', 'rtl')
      }

      this.setThemeColor(this.$route.query);
    },
    watch: {
      '$route.query': {
        handler(newQuery) {
          if(location.pathname == "/Home" || location.pathname == "/"){
            this.setThemeColor(newQuery);
          }
        },
        immediate: true,  // 立即执行一次
        deep: true
      }
    },
    methods: {
      // 设置主题色
      setThemeColor(query){
        let themeColor = JSON.parse(sessionStorage.getItem('custom-theme') || "{}" )?.primary;
        if(!query?.themeColor&&!themeColor) return;
        if(this.isValidHexColor('#' + query.themeColor)){
          setTheme({primary: '#' + query.themeColor});
        } else if(this.isValidHexColor(themeColor)){
          setTheme({primary: themeColor});
        }
      },
      isValidHexColor(color) {
          return /^#[0-9a-fA-F]{6}$/.test(color);
      },
      checkProjectConfig(){
        //存在配置 + 登录配置(默认必须要登录)
        if( this.$projectConfig && !this.$projectConfig.loginStatus){

          //登录状态失效重新登录
          if(!sessionStorage.loginStatus|| sessionStorage.loginStatus == "false"){
              this.loginStatus = "gotoLogin" 
              if(getUrlParamNotDecode().redirect_url && (location.pathname != "/" || location.pathname != "/Home")){
                  window.location.replace(decodeURIComponent(getUrlParamNotDecode().redirect_url));
              }
          }else if (sessionStorage.urlData && location.pathname == "/"){
              //必须在首页才校验登录
              this.checkImei();
          }

          if(location.pathname == "/" || location.pathname == "/Home"){
              this.SetUrlParams();
              
          }

          if(location.pathname == "/dp"){
              this.SetUrlParams({
                imei:'000000000000000', // sn 登录需固定写死imei
              });
          }
        }else{
          if(location.pathname == "/qs" || ["/pl","/ottocast"].includes(location.pathname)){
              // this.SetUrlParams();
          } else {
            if(getUrlParamNotDecode().redirect_url){
                window.location.replace(decodeURIComponent(getUrlParamNotDecode().redirect_url));
                return
            }
            //进入页面需要有配置参数
            this.$router.push({
                name: 'LoadFail',
                query:{"translateErrorMsg":'Project_Not_Exist'}
            });
          }
          
        }
      },
      SetUrlParams(data){
          // url有数据
          let urlParams =  getUrlParam();// route组件未渲染-获取URL参数
          let newData = this.refreshDefaultValue(urlParams);
          
          if(!isEmptyObject(newData) ) {
            //未登录状态才允许刷新缓存
            if( this.loginStatus == "gotoLogin" || sessionStorage['loginStatus'] != "true"){
              this.setNewData(data ? {...data,...newData} : newData);
            }
              
          }
      },
      checkImei(){
        let cI_urlParams =  getUrlParam();// route组件未渲染-获取URL参数
        let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
        //不存在IMEI登录,去失败页面
        if( !cI_urlParams.imei ){
          this.loginStatus = "loadFail"
        }else if (cI_urlParams.imei != sessionStorage_UrlData['imei']){
          //检测当前IMEI与urlIMEI不一致,重新登录  
          this.loginStatus = "gotoLogin" 
        }
      },
      refreshDefaultValue(urlParams){
          let newData = new Object();
          //必须要结束符
          if(urlParams.endString) {
              newData = {
                  ...urlParams
              };
          }

          if(!urlParams.langType){
            //重置初始语言
            newData.langType =  this.$projectConfig.langType || "en-US"   
          }

          if( !urlParams.placeCode ){
            newData.placeCode = this.$projectConfig.placeCode || "CN"
          }

          return newData;
      },
      setNewData(newData){
          sessionStorage.setItem('urlData', JSON.stringify(newData));
          this.setCookies(newData); 
          //关键配置
          this.setCoreConfig(newData);
      },
      setCoreConfig(data){
          sessionStorage.setItem('imei', data.imei);
          //当传入配置不存在，取第一次进入兜底配置。
          if(location.pathname == "/"){
            data.projectConfig && cookie.setCookie('projectConfig', data.projectConfig);    
          }
      },
      setCookies(data) {
          let appLangArray = langArray;
          

          if(isEmptyObject(data)) return;
          data.accessToken && cookie.setCookie('access_token', data.access_token);
          data.userId && cookie.setCookie('loginCustomerId', data.loginCustomerId);
          data.mvnoCode && cookie.setCookie('mvnoCode', data.mvnoCode);
          data.orgId && cookie.setCookie('orgId', data.orgId);
          data.orgCode && cookie.setCookie('orgCode', data.orgCode);


          // 默认英文
          let langType = data.langType || this.$APP_CONFIG.appDefaultLangType          
          if(!appLangArray.includes(langType)) {
              langType = this.$APP_CONFIG.appDefaultLangType
          }
          localStorage.langType = langType;
          cookie.setCookie('langType', langType,{expires: 365})
          this.$i18n.locale = langType                
      },
      debug(ele, fn) {
        var count = 0;
        var timeRange = 2000;
        var beginTime, time;
        const that = this;
        ele.addEventListener(
          "click",
          function () {
            if (count == 0) {
              beginTime = new Date().getTime();
              count++;
            } else {
              time = new Date().getTime();
              if (time - beginTime >= timeRange) {
                if (count >= 10) {
                  fn.call(that);
                  count = 0;
                } else {
                  count = 0;
                  beginTime = null;
                }
              } else {
                count++;
              }
            }
          },
          false
        );
      },
    }
  }
</script>

<style lang="less">
  @import './assets/css/common.less';
</style>